export interface GameStepsState {
  currentStep: number;
  totalSteps?: number;
}
export const state = (): GameStepsState => {
  return {
    currentStep: 0,
    totalSteps: undefined
  };
};
